<div class="panel-title">{{ 'REVIEW_PERIOD_CUSTOM_GOALS.TITLE' | translate }}</div>
<div class="scroll-panel">
    <app-dynamic-list-item (delete)="removeCustomGoal(i, item.itemSource)" (edit)="editCustomGoal(i, item.itemSource)" [inlineEdit]="false" [actionState]="actionState" *ngFor="let item of listItems; index as i" [index]="i" [source]="item">
        <div slot="readonly">
            <div class="flex-horizontal mainitems">
                
                <div class="field-text">
                    <div class="name">{{ item.itemSource.name }}</div>
                </div>                          
            </div>
            <div class="pl-3 sub-text">
                {{ 'REVIEW_PERIOD_CUSTOM_GOALS.EDITABLE_BY' | translate }} {{ getWhoCanEdit(item.itemSource) }}
            </div>

        </div>
    </app-dynamic-list-item>
</div>
<button mat-flat-button color="primary" (click)="addCustomGoal()">
    <mat-icon>add</mat-icon>
    {{ 'REVIEW_PERIOD_CUSTOM_GOALS.ADD_BUTTON' | translate }}
</button>